export default __webpack_public_path__ + "static/media/unikatneGarniture.e6954050.jpg";